<template>
  <div>
    <b-row v-if="stats">
      <b-col>
        <stats-card title="Active Pipeline"
                    type="gradient-danger"
                    :sub-title="stats.active.toString()"
                    icon="fas fa-check">
        </stats-card>
      </b-col>
      <b-col>
        <stats-card title="Potential Volume"
                    type="gradient-info"
                    :sub-title="stats.volume | currency"
                    icon="fas fa-dollar-sign">
        </stats-card>
      </b-col>
      <b-col>
        <stats-card title="Potential GCI"
                    type="gradient-warning"
                    :sub-title="stats.gci | currency"
                    icon="fas fa-dollar-sign">
        </stats-card>
      </b-col>
      <b-col>
        <stats-card title="Potential Gross Profit"
                    type="gradient-success"
                    :sub-title="stats.profit | currency"
                    icon="fas fa-dollar-sign">
        </stats-card>
      </b-col>
    </b-row>
    <b-row v-if="stats">
      <b-col>
        <stats-card title="Ratings"
                    type="gradient-danger"
                    :sub-title="stats.ratings.ten.toString()"
                    icon="">
          <template slot="info">
            <i class="fas fa-info-circle text-default" v-b-popover.hover.bottom="'Signing listing paperwork THIS MONTH.'"></i>
          </template>
          <template slot="footer">
            <b-link @click="$emit('updateRating', 10)"><strong>Total Tens</strong> <i class="fas fa-arrow-right"></i></b-link>
          </template>
        </stats-card>
      </b-col>
      <b-col>
        <stats-card title="Ratings"
                    type="gradient-danger"
                    :sub-title="stats.ratings.nine.toString()"
                    icon="">
          <template slot="info">
            <i class="fas fa-info-circle text-default" v-b-popover.hover.bottom="'Signing listing paperwork NEXT MONTH.'"></i>
          </template>
          <template slot="footer">
            <b-link @click="$emit('updateRating', 9)"><strong>Total Nines</strong> <i class="fas fa-arrow-right"></i></b-link>
          </template>
        </stats-card>
      </b-col>
      <b-col>
        <stats-card title="Ratings"
                    type="gradient-danger"
                    :sub-title="stats.ratings.eight.toString()"
                    icon="">
          <template slot="info">
            <i class="fas fa-info-circle text-default" v-b-popover.hover.bottom="'Signing listing paperwork 2 MONTHS.'"></i>
          </template>
          <template slot="footer">
            <b-link @click="$emit('updateRating', 8)"><strong>Total Eights</strong> <i class="fas fa-arrow-right"></i></b-link>
          </template>
        </stats-card>
      </b-col>
      <b-col>
        <stats-card title="Ratings"
                    type="gradient-danger"
                    :sub-title="stats.ratings.seven.toString()"
                    icon="">
          <template slot="info">
            <i class="fas fa-info-circle text-default" v-b-popover.hover.bottom="'Signing listing paperwork 3 MONTHS.'"></i>
          </template>
          <template slot="footer">
            <b-link @click="$emit('updateRating', 7)"><strong>Total Sevens</strong> <i class="fas fa-arrow-right"></i></b-link>
          </template>
        </stats-card>
      </b-col>
      <b-col>
        <stats-card title="Ratings"
                    type="gradient-danger"
                    :sub-title="stats.ratings.six.toString()"
                    icon="">
          <template slot="info">
            <i class="fas fa-info-circle text-default" v-b-popover.hover.bottom="'Signing listing paperwork 4 MONTHS.'"></i>
          </template>
          <template slot="footer">
            <b-link @click="$emit('updateRating', 6)"><strong>Total Sixes</strong> <i class="fas fa-arrow-right"></i></b-link>
          </template>
        </stats-card>
      </b-col>
      <b-col>
        <stats-card title="Ratings"
                    type="gradient-danger"
                    :sub-title="stats.ratings.five.toString()"
                    icon="">
          <template slot="info">
            <i class="fas fa-info-circle text-default" v-b-popover.hover.bottom="'Signing listing paperwork 5+ MONTHS.'"></i>
          </template>
          <template slot="footer">
            <b-link @click="$emit('updateRating', 5)"><strong>Total Fives</strong> <i class="fas fa-arrow-right"></i></b-link>
          </template>
        </stats-card>
      </b-col>
    </b-row>
    <div class="text-right mb-3" v-if="rating !== ''">
      <b-button variant="danger" @click="$emit('updateRating', '')">Clear Ratings Filter</b-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [errorsMixin],
  props: {
    year: null,
    type: null,
    userRoute: null,
    rating: null,
    status: null,
    transferred: null
  },
  data() {
    return {
      stats: null
    }
  },
  methods: {
    async getStats() {
      const params = "?year=" + this.year + "&type=" + this.type + "&rating=" + this.rating + "&status=Active&transferred=" + this.transferred;
      axios.get(this.userRoute + "/pipeline-totals" + params)
      .then(response => {
        this.stats = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    }
  },
  created() {
    this.getStats()
  },
  watch: {
    year(to, from) {
      this.getStats();
    },
    type(to, from) {
      this.getStats();
    },
    rating(to, from) {
      this.getStats();
    },
    status(to, from) {
      this.getStats();
    }
  }
};
</script>